module.exports = vendorCore;